export const apiURL = process.env.REACT_APP_API_URL;
export const pythonApiURL = process.env.REACT_APP_PYTHON_API_URL;
//export const stgURL = process.env.REACT_APP_API_STG_URL;
//export const prodURL = process.env.REACT_APP_API_URL;